import { I18n } from "../services/I18n";
import core_types_sites from "../core-types-sites-translations-hr";
import common from "../common-translations-hr";
import generated from "./generated/site-translations-hr";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, core_types_sites);
I18n.translations = I18n.extend(I18n.translations, common);
